/* global $:false */

export default class ReadMore {
  static init () {
    Array.from($('.js-read-more')).map((el) =>
      new ReadMore(el))
  }

  constructor (el) {
    this.el = $(el)
    this.setupBindings()
  }

  setupBindings () {
    this.el.click(event => {
      event.preventDefault()
      const fulltext = $('.' + this.el.data('fulltext'))
      fulltext.show()
      this.el.parent().remove()
    })
  }
}
